import { REQUEST_THREAD_ENTITY } from '../../../constants/entity'
import {
  deleteApi,
  getApi,
  getId2IdEndpoint,
  patchApi,
  postApi,
  putApi,
} from '../../../utils/api'

import { REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE } from './RequestProfileTabEmails.constants'

function getRequestThreadsEndpointBase({ outboundUuid, requestId }) {
  return outboundUuid
    ? `idwell-api/api/v3/idwell-to-idwell/${outboundUuid}/requests/${requestId}`
    : `idwell-api/api/v3/request/requests/${requestId}`
}

export const REQUEST_THREADS_TABLE_CONFIG_SAVE_API = `idwell-api/api/v3/table/tables/${REQUEST_THREAD_ENTITY.plural}/config/`

export const REQUEST_THREADS_SINGLE_FIELD_API =
  'idwell-api/api/v3/request/request-threads/single-field/'

export function getRequestThreadsListApi({ outboundUuid, requestId }) {
  return `${getRequestThreadsEndpointBase({ outboundUuid, requestId })}/request-threads/filter/`
}

export function getRequestThreadsFilterStateApi(requestId) {
  return `idwell-api/api/v3/table/filter-states/${REQUEST_THREAD_ENTITY.plural}/all/?object_id=${requestId}`
}

export function getRequestThreadsSingleFieldApi(requestId) {
  return `${REQUEST_THREADS_SINGLE_FIELD_API}?request=${requestId}`
}

export function updateRequestThreadsTableConfig(data) {
  return putApi({
    data,
    endpoint: REQUEST_THREADS_TABLE_CONFIG_SAVE_API,
  })
}

export function toggleRequestThreadRead({
  outboundUuid,
  read,
  requestId,
  uuid,
}) {
  return postApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `request/${requestId}/email-thread/${uuid}/${read ? 'read' : 'unread'}/`,
    }),
  })
}

export function updateRequestThread({ data, requestId, uuid }) {
  return patchApi({
    data,
    endpoint: `api/request/${requestId}/email-thread/${uuid}/`,
  })
}

export function deleteRequestThread({ requestId, uuid }) {
  return deleteApi({
    endpoint: `api/request/${requestId}/email-thread/${uuid}/`,
  })
}

export function moveRequestThreadToRequest({ newRequestId, requestId, uuid }) {
  return postApi({
    endpoint: `api/request/${requestId}/email-thread/${uuid}/move/${newRequestId}/`,
  })
}

export function performRequestThreadsMassAction({ data, requestId }) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/request/requests/${requestId}/request-threads/mass-action/`,
  })
}

export function copyRequestEmailMessageToEntity({ data, requestId, uuid }) {
  return postApi({
    data,
    endpoint: `api/request/${requestId}/email-message/${uuid}/copy_to_archive/`,
  })
}

export function deleteRequestEmailMessage({ id, requestId }) {
  return deleteApi({
    endpoint: `api/request/${requestId}/email-message/${id}/`,
  })
}

export function resendRequestEmailMessage({ requestId, uuid }) {
  return postApi({
    data: { uuid },
    endpoint: `api/request/${requestId}/email-message/${uuid}/resend/`,
  })
}

export function deleteRequestEmailMessageCopiedEntity({
  data,
  requestId,
  uuid,
}) {
  return postApi({
    data,
    endpoint: `api/request/${requestId}/email-message/${uuid}/delete_from_archive/`,
  })
}

export function getRequestEmailMessageFiles({
  object_id: uuid,
  outboundUuid,
  requestId,
  ...restParams
}) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `request/${requestId}/email-message/${uuid}/files/`,
    }),
    params: restParams,
  })
}

export function getRequestEmailMessageRaw({
  outboundUuid,
  params,
  requestId,
  uuid,
}) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `request/${requestId}/email-message/${uuid}/raw-text/`,
    }),
    params,
  })
}

export function getRequestEmailMessages({
  options,
  outboundUuid,
  params,
  requestId,
}) {
  return getApi({
    endpoint: `${getRequestThreadsEndpointBase({ outboundUuid, requestId })}/email-messages/`,
    options,
    params,
  })
}

export function getRequestThreadProfile({
  options,
  outboundUuid,
  params,
  requestId,
  uuid,
}) {
  return getApi({
    endpoint: `${getRequestThreadsEndpointBase({ outboundUuid, requestId })}/request-threads/${uuid}/`,
    options,
    params,
  })
}

export function getRequestThreadNavigation({
  data,
  options,
  outboundUuid,
  requestId,
  threadUuid,
}) {
  return postApi({
    data,
    endpoint: `${getRequestThreadsEndpointBase({ outboundUuid, requestId })}/request-threads/${threadUuid}/navigation/`,
    options,
  })
}

export function getRequestProfileEmailThreadsTotal({
  audience,
  outboundUuid,
  requestId,
}) {
  const params = {}

  if (audience) {
    params[REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE] = audience
  }

  return getApi({
    endpoint: `${getRequestThreadsEndpointBase({ outboundUuid, requestId })}/request-threads/total/`,
    params,
  })
}
